import { render, staticRenderFns } from "./student-policy-detail-info.vue?vue&type=template&id=0a6b0633&scoped=true&"
import script from "./student-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./student-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./student-policy-detail-info.vue?vue&type=style&index=0&id=0a6b0633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b0633",
  null
  
)

export default component.exports